import React, { useState, useRef } from "react";
import { toast } from "react-toastify";
import { Navigate, useNavigate } from "react-router-dom";
import {
  LoginAPi,
} from "../actioncreators/actioncreators";
import "../../App.css";
import brandConfig from "../../brandConfig";
import LoginPng from "../Assets/login.png";
import { useDispatch } from "react-redux";
import { emailId } from "../actions/loanAction";

const Freeplan = () => {
  const [email, setEmail] = useState("");
  const [isButtonEnabled, setIsButtonEnabled] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const handleInputChange = (e) => {
    const enteredEmail = e.target.value;
    setEmail(enteredEmail);

    // Enable the button if an email is entered
    setIsButtonEnabled(enteredEmail.trim().length > 0);
  };

  const handleLoginClick = async (e) => {
    e.preventDefault(); // Prevent form submission reload
    // Clear menu state to ensure Dashboard is highlighted on login
    localStorage.removeItem("activeMainIndex");
    localStorage.removeItem("activeSubIndex");
    localStorage.removeItem("label");
    navigate("/home");
  };

  return (
   
    <div className="row p-0 m-0">
    <header className="col-12 col-md-12 shadow-sm" style={{ backgroundColor: 'var(--brand-primary)' }}>
      <div className="px-3 py-2">
        <img src={brandConfig.logoPath} alt={brandConfig.appName} className="h-10" data-brand-logo="true" />
      </div>
    </header>

    <main className="row p-3 m-0 " style={{ backgroundColor: "#edeef2" ,height:"90vh"}} >
      <div className="col-12 col-md-1"></div>

      {/* Left Column */}
      <div className="col-12 col-md-6 bg-white rounded-lg p-2 text-center items-center shadow-lg mx-2 mt-3">
        {" "}
        {/* Added mx-2 for horizontal margin */}
        <img
          src={LoginPng}
          alt="ArthaTRACK"
          className=" h-auto mx-auto object-contain"
          style={{ width: "60%" }}
        />
        <p className="text-center custom-blue-text">
        Streamline attendance, payroll, and compliance by easily tracking when your team is working.
        </p>
      </div>

      {/* Right Column */}
      <div className="col-12 col-md-4 bg-white rounded-lg shadow-lg p-5 mx-2 mt-3 shadow-sm text-center">
        {/* Blinking Free Plan badge */}
        <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
          <span
            style={{
              background: "#28a745",
              color: "#fff",
              borderRadius: "20px",
              padding: "6px 18px",
              fontWeight: "bold",
              fontSize: "1rem",
              marginBottom: "10px",
              marginTop: "-10px",
              animation: "blinker 1.2s linear infinite"
            }}
          >
            <span role="img" aria-label="gift" style={{ marginRight: 6 }}>🎁</span>
            Free Plan
          </span>
        </div>
        <style>
          {`
            @keyframes blinker {
              50% { opacity: 0.5; }
            }
          `}
        </style>
        <h1 className="fw-bold mt-3 text-center text-2xl fs-4">Enjoy Your Free Trial!</h1>
        <p className="mb-3 text-center text-muted" style={{ fontSize: "1rem" }}>
          You have been granted a complimentary Free Trial with full access to all premium features.<br />
          Click <b>Go To Dashboard</b> to start exploring them.
        </p>
        <button
          type="button"
          onClick={handleLoginClick}
          className="w-75 fw-bold py-3 mt-3 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white"
          style={{ backgroundColor: 'var(--brand-accent)' }}
        >
         Go To Dashboard
        </button>
      </div>

      <div className="col-12 col-md-1"></div>
    </main>
  </div>
  );
};

export default Freeplan;
